var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.201 4.7505L9.27508 4.82585C9.4354 6.80266 8.15887 8.6108 6.23941 9.12512C4.04927 9.71197 1.78981 8.40747 1.20297 6.21733C0.61612 4.0272 1.9208 1.76769 4.11093 1.18084C5.21408 0.885258 6.36911 1.06402 7.31684 1.6423L6.80729 2.09337C6.75768 2.13725 6.7351 2.20448 6.74832 2.26961C6.74915 2.27343 6.74989 2.27689 6.7509 2.28066C6.76696 2.34061 6.81204 2.38894 6.87142 2.40881L9.17268 3.17865C9.23564 3.19967 9.30518 3.18566 9.35474 3.1416C9.40435 3.09771 9.42693 3.03049 9.41371 2.96535L8.92976 0.58701C8.91671 0.526829 8.86985 0.468975 8.80666 0.447817C8.7437 0.426789 8.67416 0.440805 8.6246 0.484866L8.03821 1.00385C6.83539 0.173613 5.31662 -0.104101 3.87046 0.283394C1.18547 1.00284 -0.413747 3.77276 0.305695 6.45776C1.02514 9.14275 3.79506 10.742 6.48006 10.0225C8.83281 9.39211 10.3979 7.17478 10.201 4.7505Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryWhite);
export default __webpack_public_path__ + "static/media/retry-white.336362d9e44556d8266f2e8c57d4dab0.svg";
export { ForwardRef as ReactComponent };